import script from "./customer-index.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-index.vue?vue&type=script&setup=true&lang=js"

import "./customer-index.vue?vue&type=style&index=0&id=b809a394&lang=css"

const __exports__ = script;

export default __exports__